// extracted by mini-css-extract-plugin
export default {"loading":"dcc_loadingIndicator-loading"};